import styled from '@emotion/styled';
import { Dialog, LinearProgress } from '@mui/material';
import { teal } from 'Styles/colors';
import Button from 'Stories/components/Button';
import { breakpoints } from 'Styles/theme';
import { leaf } from 'Assets/img/screening-icons';
import { Bookmark, LikertForm } from '../../styles';

export const StyledLikertForm = styled(LikertForm)(
  ({ theme }) => `
  width: 100%;
  flex-flow: wrap;
  justify-content: center;
  column-gap: 30px;

  ${theme.breakpoints.up(breakpoints.DESKTOP)} {
    max-width: 380px;
  }

  .FormQuestion-answer-card {
    width: 147px;
    height: 115px;
  }
`,
);

export const NeedsWrapper = styled(Dialog)(
  ({ theme }) => `

  h1 {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin: 32px auto;
  }
  
  ${theme.breakpoints.up(breakpoints.TABLET)} {
    h1 {
      font-size: 24px;
    }
  }

  .MuiDialog-scrollPaper {
    background-image: linear-gradient(rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.68)), url(${leaf}), linear-gradient(black, black);
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
  }

  .MuiDialog-paper {
    display: grid;
    grid-template-rows: 1fr 2fr 1fr;
    background-color: transparent;
    color: white;
    align-items: center;
    justify-content: center;
  }

  ${theme.breakpoints.up(breakpoints.TABLET)} {
    .MuiDialog-paper {
      grid-template-rows: 1fr 5fr 1fr;
    }
  }
  `,
);

export const NeedsProgressBar = styled(LinearProgress)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 9px;
  margin-top: env(safe-area-inset-top);

  .MuiLinearProgress-bar {
    background-color: ${teal._400};
  }
`;

export const StyledBookmark = styled(Bookmark)`
  top: calc(9px + env(safe-area-inset-top));
`;

export const SubmitButton = styled(Button)`
  position: fixed;
  bottom: 2rem;
  width: calc(100% - 2rem);
  max-width: 800px;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 1000;
`;

export const StyledNeedsForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  .question-card {
    background-color: ${(props) => (props.cardColor ? props.cardColor : teal._400)};
    width: 100%;
    max-width: 340px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0 12px 0 -10px rgba(0, 0, 0, 0.2), 0 16px 0 -12px rgba(0, 0, 0, 0.15), 0 18px 0 -13px rgba(0, 0, 0, 0.1),
      0 22px 0 -15px rgba(0, 0, 0, 0.05);
    margin-bottom: 1.5rem;
    padding: 1.5rem 1rem;
    color: white;
    transition: background-color 0.3s ease;
    overflow-y: auto;
    max-height: 80vh;
  }

  .question-text {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0 auto 1.5rem auto;
  }

  .answer-container {
    width: 100%;
    max-width: 320px;
  }
`;
